define('plugin/membership/view/MembershipIndexView',['require','plugin/membership/view/MembershipCommonView','plugin/membership/view/MembershipListView','plugin/membership/view/MembershipFilterView','view/module/MessageView','lib/pager/view/PagerView'],function (require) {

    var MembershipCommonView = require('plugin/membership/view/MembershipCommonView');
    var MembershipListView = require('plugin/membership/view/MembershipListView');
    var MembershipFilterView = require('plugin/membership/view/MembershipFilterView');
    var MessageView = require('view/module/MessageView');
    var PagerView = require('lib/pager/view/PagerView');


    /**
     * Membership index view
     *
     * @class MembershipIndexView
     */
    return MembershipCommonView.extend({

        onBeforeShow: function() {
            var filter = this.getOption('filterData');
            if (!filter) {
                filter = {};
            }
            if (filter.services) {
                filter.services = filter.services.split(',');
            }

            this.showChildView('list', new MembershipListView({
                collection: this.getOption('collection'),
                serviceCollection: this.getOption('serviceCollection'),
                filterData: filter,
                type: this.getOption('type'),
                highlighted: this.getOption('highlighted'),
            }));
            if (this.getOption('withFilter')) {
                this.showChildView('filter', new MembershipFilterView({
                    collection: this.getOption('serviceCollection'),
                    filterData: filter
                }));
            }
            if (this.getOption('status_str')) {
                this.showChildView('status', new MessageView({
                    type: 'info',
                    message: 'membership_status_message_' + this.getOption('status_str')
                }));
            }

            if (this.getOption('collection').getPager) {
                this.showChildView('pager', new PagerView({
                    pager: this.getOption('collection').getPager(),
                    url: this.getOption('url')
                }));
            }
        },


        serializeData: function () {
            var data = MembershipCommonView.prototype.serializeData.apply(this, arguments);
            data.is_id_filter = this.getOption('filterData') && this.getOption('filterData').id;
            return data;
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'membership'
            });
        }

    });

});
